/**
 * Crash and error reporting for the staff panel.  CA-19.
 *
 * Ported from prototype/assets/client-errors.js (which the TV page keeps).
 * Sends only the message, a few stack lines and the page path to POST
 * /v1/client-errors — never form values, never the session. The server
 * scrubs every report again and decides whether it pages anyone; in the
 * panel that is when the same error repeats. Capped per page load so a loop
 * cannot flood it, and reporting can never itself be a second error.
 */
import { API } from './api';

let total = 0;
const per: Record<string, number> = {};

export function report(kind: string, message: unknown, stack?: unknown) {
  try {
    const msg = String(message ?? '').slice(0, 300);
    if (total >= 20 || (per[msg] = (per[msg] || 0) + 1) > 5) return;
    total += 1;
    const body = JSON.stringify({ surface: 'admin', kind, message: msg,
      stack: String(stack || '').split('\n').slice(0, 8).join('\n'), where: location.pathname + location.hash.replace(/\?.*$/, ''), screen: null });
    // sendBeacon survives the page going down; text/plain needs no preflight.
    if (navigator.sendBeacon && navigator.sendBeacon(API + '/client-errors', new Blob([body], { type: 'text/plain' }))) return;
    fetch(API + '/client-errors', { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body, keepalive: true }).catch(() => {});
  } catch { /* never a second error */ }
}

export function installReporting() {
  window.addEventListener('error', (ev) => {
    // A failed <img>/<link> has no error object: a network hiccup, not a fault.
    if (!ev.error && ev.target && ev.target !== window) return;
    report('error', ev.message || (ev.error && ev.error.message), ev.error && ev.error.stack);
  }, true);
  window.addEventListener('unhandledrejection', (ev) => {
    const r = ev.reason;
    report('unhandledrejection', r && r.message ? r.message : r, r && r.stack);
  });
}
